/** Applied to `document.body` while dragging (optional consumer hooks for CSS). */
export const DRAG_RESIZE_1D_BODY_CLASS = "drag-resize-1d-active";

export const CURSOR_DRAG_RESIZE_HORIZONTAL = "ew-resize";
export const CURSOR_DRAG_RESIZE_VERTICAL = "ns-resize";
